import { zodResolver } from '@hookform/resolvers/zod';
import * as z from 'zod';

const schema = z.object({
  code: z.array(z.any()).refine((value) => {
    return value.join('').length >= 6;
  })
});

export const CodeValidator = zodResolver(schema);
